import {isNil} from 'lodash';
import {useCallback} from 'react';
import {t} from '../../../../common/getTranslations';
import {requestContext} from '../../../../common/requestContext';
import {
  ContentProductCursorIndexQuery,
  SortOption,
} from '../../../../graphql/generated/types';
import {showToast} from '../../../../toast/toastHandler';
import {useContentProductCursorIndexQuery} from '../../../../wrapper/contentWrapper';
import {PRODUCT_LIST_ROW_HEIGHT} from '../constant';

export function useContentProductListAnchor({
  seriesId,
  selectedSortOption,
}: {
  seriesId: number;
  selectedSortOption?: SortOption;
}) {
  const {isMobile} = requestContext.requestInfo.display;

  const onClickAnchorIndex = useCallback(
    (data: ContentProductCursorIndexQuery) => {
      if (isNil(data?.contentProductCursorIndex)) {
        return;
      }
      const virtualListElement = document.getElementsByClassName(
        'ReactVirtualized__Grid ReactVirtualized__List'
      )[0];
      // virtualList의 window 기준 top 위치
      const virtualListTop =
        window.scrollY + virtualListElement.getBoundingClientRect().top;
      window.scrollTo(
        0,
        virtualListTop +
          PRODUCT_LIST_ROW_HEIGHT *
            Math.max(data.contentProductCursorIndex - 1, 0) -
          window.innerHeight / 2
      );
    },
    []
  );

  const {refetch} = useContentProductCursorIndexQuery(
    {
      seriesId,
      sortType: selectedSortOption?.param,
    },
    {
      enabled: false,
      throwOnError: true,
    }
  );

  const triggerAnchor = useCallback(async () => {
    try {
      const result = await refetch();
      if (result.data) {
        onClickAnchorIndex(result.data as ContentProductCursorIndexQuery);
      }
    } catch {
      showToast({
        message: t('error_api_toast'),
        isMobile,
      });
    }
  }, [refetch, onClickAnchorIndex, isMobile]);

  return {
    triggerAnchor,
  };
}
